export enum CalculationError {
    INCOME_FINANCIAL_OBLIGATION = 'Calculation error due to low income or high costs',
    EXTRA_ASSET = 'Calculation error due to high extra assets'
}
